import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import "./adminStudentsList.css";
import SideBar from "../../commanComponents/sidebar/sidebar";
import { titleCase } from '../../../utils/utils';
import { clearData } from '../../../utils/localStorage';
import AdvancedTable from "../../commanComponents/advancedTable/advancedTable";
import TopNavigation from "../../commanComponents/topNavigation/topNavigation";
import { ROUTES, sidebarNavItems } from '../../../constant';
import { getStudentListService, getSessionListService, getClassListService, getSectionListService } from "../../../modules/services";
import PopoverFilter from "../../commanComponents/popoverFilter/popoverFilter";


const StudentList = () => { 
    const [dataMeta, setDataMeta] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [pagNo, setPageNo] = useState(1);
    const [sessionData, setSessionData] = useState([]);
    const [classData, setClassData] = useState([]);
    const [sectionData, setSectionData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const FilterSchema = z.object({
        //session_filter
        session_filter: z.string(),
        //school_filter
        school_filter: z.string(),
        //class_filter
        class_filter: z.string(),
        //section_filter
        section_filter: z.string(),
    });
    const { control: filterControl, getValues: filterGetValues, setValue: filterSetValue } = useForm({
        resolver: zodResolver(FilterSchema)
    });

    const renderDropdownListData = (listData, label, value, id) => {
        return(listData.map(data => ({label: data[label], value: data[value], id: data[id]})))
    }

    const getStudentListData = (pageNo, fromFilter = false) => {
        const sessionFilterData = filterGetValues("session_filter");
        const classFilterData = filterGetValues("class_filter");
        const sectionFilterData = filterGetValues("section_filter");
        setIsLoading(true);
        (async () => {
            const responseData = await getStudentListService({
                page: pageNo,
                enrolled_student_session__session: typeof sessionFilterData === "undefined" ? "" : sessionFilterData,
                user_class: typeof classFilterData === "undefined" ? "" : classFilterData,
                section: typeof sectionFilterData === "undefined" ? "" : sectionFilterData,
                pagination: true
            });
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                if (fromFilter) {
                    setDataList(responseData.data[0].results);
                 }
                else {
                    setDataList([...dataList, ...responseData.data[0].results]);
                }

                setDataMeta(responseData.data[0].links);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
                toast.error(responseData.data.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            else {
                clearData();
                toast.error(responseData.data.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                });
                navigate(ROUTES.LOGIN);
            }
        })();
    };

    const getSessionData = () => { 
        setIsLoading(true);
        (async () => {
            const responseData = await getSessionListService({pagination: false});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                const sessionList = renderDropdownListData(responseData.data, "session_name", "id", "id");
                setSessionData(sessionList);
                filterSetValue("session_filter", sessionList[0]?.value);
                getStudentListData(pagNo);

                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    const getClassData = () => { 
        setIsLoading(true);
        (async () => {
            const responseData = await getClassListService({pagination: false});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                let classList = renderDropdownListData(responseData.data, "name", "id", "id");
                classList = [{ label: "Select", value: "", id: undefined }, ...classList];

                setClassData(classList);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    const getSectionData = () => { 
        setIsLoading(true);
        (async () => {
            const responseData = await getSectionListService({pagination: false});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                let sectionList = renderDropdownListData(responseData.data, "name", "id", "id");
                sectionList = [{ label: "Select", value: "", id: undefined }, ...sectionList];

                setSectionData(sectionList);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    useEffect(() => {
        getSessionData()
        
        getClassData();
        getSectionData();
    }, []);

    const handleLoadMore = () => {
        if (dataMeta.next) {
            setIsLoading(true);
            const _pageNo = dataMeta.current + 1;
            setPageNo(_pageNo);
            getStudentListData(_pageNo);
        }
    }

    const onClickDetail = () => {

    }

    const handleClassFilterChange = () => { 
        const _pageNo = 1;
        setPageNo(_pageNo);
        getStudentListData(_pageNo, true);
    }

    const handleSectionFilterChange = () => { 
        const _pageNo = 1;
        setPageNo(_pageNo);
        getStudentListData(_pageNo, true);
    }
    
    const tableColumns = [
        {
            accessor: prop => prop.first_name + " " + prop.last_name,
            Header: 'Full Name',
            onClick: true,
            minWidth: 170
        },
        // {
        //     accessor: 'email',
        //     Header: 'Email',
        //     minWidth: 170,
        // },
        {
            accessor: 'frl_id',
            Header: 'FRL ID',
            minWidth: 170,
        },
        // {
        //     accessor: 'school_name',
        //     Header: 'School Name',
        //     isFilter: false,
        //     minWidth: 190
        // },
        {
            accessor: 'user_class',
            Header: 'Class',
            isFilter: true,
            minWidth: 190,
            popoverFilter: PopoverFilter,
            filterDataList: classData,
            control: filterControl,
            inputKey: "class_filter",
            placeholder: "Class",
            onChange: handleClassFilterChange,
        },
        {
            accessor: 'section_name',
            Header: 'Section',
            isFilter: true,
            minWidth: 190,
            popoverFilter: PopoverFilter,
            filterDataList: sectionData,
            control: filterControl,
            inputKey: "section_filter",
            placeholder: "Section",
            onChange: handleSectionFilterChange,
        },
        {
            accessor: prop => titleCase(prop.status),
            Header: 'Status',
            minWidth: 170,
        },
    ];


    return (
        <div className='student-list-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.adminStudents} />
            <div className='student-list-side-container'>
                <TopNavigation activeItem={sidebarNavItems.adminStudents} />
                
                <div className='row student-list-filter-container'>
                </div>
                
                <div className='student-list-main-container'>
                    <AdvancedTable columns={tableColumns} data={[...dataList]} isLoading={isLoading} handleLoadMore={handleLoadMore} onClickDetails={onClickDetail} rowCount={dataMeta.count} />
                </div>
            </div>
        </div>
    );
}


export default StudentList;
